exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-item[data-v-c55dfcc4]:hover{transform:translateY(-5px) scale(1.005) translateZ(0);box-shadow:0 24px 36px rgba(0,0,0,.11),0 14px 16px rgba(0,0,0,.11)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c55dfcc4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inventario_Componentes/SubMenuSalidas.vue
// module id = 1984
// module chunks = 0